import { CONDITION_BRANCH_PREFIX, DEFAULT_CONDITION_BRANCH_ID } from '../constants'

export const getBranchId = (branch: number | string) => {
    branch = branch.toString().toLowerCase()
    return branch === 'default' ? DEFAULT_CONDITION_BRANCH_ID : `${CONDITION_BRANCH_PREFIX}${branch}`
}
